import React, { useState } from "react";
import styled from "styled-components";
import Logo from "./Logo"

const Section = styled.section`
    width: 100vw;
    background-color: ${props => props.theme.body};
`

const NavBar = styled.nav`
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 85%;
    height: ${props => props.theme.navHeight};
    margin: 0 auto;

    .mobile {
        display: none;
    }

    @media (max-width: 64em) {
        .desktop {
            display: none;
        }

        .mobile {
            display: inline-block;
        }
    }
`

const Menu = styled.ul`
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;

    @media (max-width: 64em) {
        position: fixed;
        top: ${props => props.theme.navHeight};
        left: 0;
        right: 0;
        bottom: 0;
        width: 100vw;
        height: ${props => `calc(100vh -${props.theme.navHeight})`};
        z-index: 50;
        background-color: ${props => `rgba(${props.theme.bodyRgba}, 0.85)`};

        transform: ${props => props.click ? 'translateY(0)' : `translateY(100%)`};
        transition: all 0.3s ease;
        backdrop-filter: blur(2px);
        flex-direction: column;
        justify-content: center;
    }
`

const MenuItem = styled.li`
    margin: 0 1rem;
    color: ${props => props.theme.text};
    cursor: pointer;

    &::after {
        content: ' ';
        display: block;
        width: 0%;
        height: 2px;
        background: ${props => props.theme.text};
        transition: width 0.3s ease;
    }

    &:hover::after {
        width: 100%;
    }

    @media (max-width: 64em) {
        margin: 1rem 0;

        &::after {
            display: none;
        }
    }
`

const HamburgerMenu = styled.span`
    width: 1.5rem;
    height: 2px;
    background: ${props => props.theme.text};

    display: none;
    justify-content: center;
    align-items: center;

    transform: translateX(-50%);
    cursor: pointer;

    @media (max-width: 64em) {
        display: flex;
    }

    &::after, &::before {
        content: ' ';
        width: 1.5rem;
        height: 2px;
        background: ${props => props.theme.text};
        position: absolute;
    }

    &::after {
        top: 0.5rem;
    }
    
    &::before {
        bottom: 0.5rem;
    }
`

const Button = styled.button`
    background: ${props => props.theme.text};
    color: ${props => props.theme.body};
    padding: 0.6rem;
    border-radius: 0.3rem;
    cursor: pointer;
`

const Navigation = () => {

    const scrollTo = (id) => {
        let element = document.getElementById(id);

        element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
        })

        setClick(!click);
    }

    const [click, setClick] = useState(false)
    return (
        <Section>
            <NavBar>
                <Logo />
                <Menu click={click}>
                    <MenuItem onClick={() => scrollTo('home')}>Home</MenuItem>
                    <MenuItem onClick={() => scrollTo('about')}>About</MenuItem>
                    <MenuItem onClick={() => scrollTo('team')}>Team</MenuItem>
                    <MenuItem onClick={() => scrollTo('faq')}>Faq</MenuItem>
                    <div className="mobile">
                        <Button>Connect Wallet</Button>
                    </div>
                </Menu>
                <div className="desktop">
                    <Button>Connect Wallet</Button>
                </div>
                <HamburgerMenu click={click} onClick={() => setClick(!click)}>
                    &nbsp;
                </HamburgerMenu>
            </NavBar>
        </Section>
    )
}

export default Navigation